import createTempId from '@/helpers/createTempId'
import store from '../store/index'
import { getItemPropertySource } from '../helpers/getEffectiveItemType'
import getCharacterArmourDexPen from '../helpers/getCharacterArmourDexPen'
//------------------------------------------------------------------------------------------------------
// process add equipped armour (add armour to armour_location/equipped armour arrays for frontend only)
//------------------------------------------------------------------------------------------------------
export default function processAddEquippedArmour({
  static_armour = null,
  equipped_armour = null,
  character = null,
}) {
  console.log('----------------------------------------------')
  console.log('IN processAddEquippedArmour parms = ', { static_armour, equipped_armour, character })
  /*
    - static_armour = static (item) armour object (from store) for the equipped armour being added
    - equipped_armour = equipped armour (new/existing character item with equipped = true)
    - character = character object
  */
  //-------------
  // check parms
  //-------------
  if (!static_armour || !equipped_armour || !character) {
    console.error('*** processAddEquippedArmour - Missing parms:', {
      static_armour,
      equipped_armour,
      character,
    })
    return
  }
  //-------------------------------------------------------------------------------------------------
  // should be armour locations even if no equipped armour (or is new character - albeit ids = temp)
  //-------------------------------------------------------------------------------------------------
  if (!character.armour_locations || !Array.isArray(character.armour_locations)) {
    console.error('*** processAddEquippedArmour - Invalid armour_locations:', {
      armour_locations: character.armour_locations,
    })
    return
  }

  console.log(
    'processAddEquippedArmour current character armour_locations = ',
    character.armour_locations,
  )

  const getStaticItemById = store.getters?.['characters/getStaticItemById']
  const resolvedStaticArmour =
    typeof getStaticItemById === 'function'
      ? getItemPropertySource(static_armour, getStaticItemById)
      : static_armour

  if (!resolvedStaticArmour?.armour) {
    console.error('*** processAddEquippedArmour - Missing armour definition on static item:', {
      static_armour,
      resolvedStaticArmour,
    })
    return
  }
  //=====================================================================================
  // INTERNAL FUNCTION - create equipped armour entry
  //--------------------------------------------------
  function _createEquippedArmourEntry({ static_armour, equipped_armour, coverage_name = null }) {
    const material = static_armour?.armour?.armour_material || {}
    // Prefer the character item's current AP (which may have been
    // edited in the UI) and fall back to the static material AP
    // only when the character item doesn't yet have an ap value.
    const apSource =
      equipped_armour.ap !== undefined && equipped_armour.ap !== null
        ? equipped_armour.ap
        : material.ap
    const ap = Number(apSource) || 0
    const dexPenFactor = Number(material.dex_pen_factor) || 0
    // Prefer the character item's current HP (which may have been
    // edited in the UI) and fall back to the static material HP
    // only when the character item doesn't yet have an hp value.
    const hpSource =
      equipped_armour.hp !== undefined && equipped_armour.hp !== null
        ? equipped_armour.hp
        : material.hp
    const hp = hpSource !== undefined && hpSource !== null ? hpSource : null

    // Mirror backend CharacterLocationEquippedArmour.get_armour_dex_pen_percent:
    // per-location dex pen is ap * dex_pen_factor (no multiplication by
    // total location count; that only happens at the Item level).
    const dexPenPerLocation = ap * dexPenFactor

    return {
      ap,
      armour: equipped_armour.id, // character item id
      armour_name: equipped_armour.name,
      dex_pen_factor: dexPenFactor,
      dex_pen: dexPenPerLocation,
      hp,
      id: createTempId(), // character location equipped armour id (temp id for new item)
      layer: material.layer,
      // Prefer a specific armour_location_name on the character item (e.g.
      // "Lower Right Leg") when present; fall back to the generic
      // coverage_name from the static definition otherwise.
      coverage: equipped_armour.armour_location_name || coverage_name,
    }
  }
  //=====================================================================================
  // INTERNAL FUNCTION - recalc aggregates at character armour location level
  // (mirrors backend CharacterArmourLocation.get_dex_pen_percent/get_highest_ap and
  // adds highest_layer as max equipped layer)
  //----------------------------------------------------------------------------------
  function _updateLocationAggregates(character_armour_location) {
    console.log('-------------------------------------------------------------------')
    console.log(`IN _updateLocationAggregates for location: ${character_armour_location.armour_location_name}`, {
      character_armour_location,
    })
    if (!character_armour_location) return

    const equipped = Array.isArray(character_armour_location.equipped_armour)
      ? character_armour_location.equipped_armour
      : []

    // armour_count: only entries with a non-null armour id
    const armour_count = equipped.filter((ea) => ea && ea.armour != null).length

    let highest_ap = 0
    let highest_layer = 0
    let dex_pen = 0
    // let half_location = character_armour_location.half_location || false

    equipped.forEach((ea) => {
      if (!ea) return

      console.log('++++++++++++++++++++++++++++++++++++++', { ea })

      const ap = Number(ea.ap) || 0
      if (ap > highest_ap) highest_ap = ap

      const layer = Number(ea.layer)
      if (!Number.isNaN(layer) && layer > highest_layer) {
        highest_layer = layer
      }

      const dp = Number(ea.dex_pen) || 0

      // if (half_location) {
      //   dex_pen += dp / 2
      // } else {
        dex_pen += dp
      // }
      console.log('dex_pen += ', dp, ' => dex_pen = ', dex_pen)})

    character_armour_location.armour_count = armour_count
    character_armour_location.highest_ap = highest_ap
    character_armour_location.highest_layer = highest_layer
    character_armour_location.dex_pen = dex_pen

    console.log('OUT _updateLocationAggregates for location: ', character_armour_location.location_name, '/ dex_pen = ', dex_pen)
  }
  //=====================================================================================
  // INTERNAL FUNCTION - recalc overall character dex_pen_percent_armour
  // (mirrors backend get_dex_pen_percent_armour: sum of dex_pen_percent
  // over all CharacterLocationEquippedArmour entries via per-location totals)
  //---------------------------------------------------------------------------
  function _updateCharacterDexPenArmour(character) {
    if (!character) return
    character.dex_pen_percent_armour = getCharacterArmourDexPen(character)
  }
  //=============================================================================================
  //
  // MAIN FLOW
  //
  // MAP EQUIPPED ARMOUR TO CHARACTER ARMOUR LOCATIONS USING MATCHING ARMOUR LOCATION NAMES
  //
  //=============================================================================================
  // coverage locations either:
  // (A) fixed - use all static item armour coverage loc names OR
  // (B) non-fixed - use selected armour loc (id) to find specific coverage loc name within possible coverage locs
  // NB: at the moment equipped_armour may be empty or have other armour equipped to one or more locations
  //=====================================================================================
  // SCENARIO B - non-fixed selected coverage (will ONLY be one location when selecting)
  //-------------------------------------------------------------------------------------
  if (equipped_armour.armour_location) {
    // use static coverage locations from the armour definition; this avoids relying on
    // equipped_armour.coverage_locations which may be missing on the character item
    const staticCoverageLocs = Array.isArray(resolvedStaticArmour?.armour?.coverage_locations)
      ? resolvedStaticArmour.armour.coverage_locations
      : []

    if (!staticCoverageLocs.length) {
      console.error(
        '*** processAddEquippedArmour - No static coverage_locations found on static_armour:',
        {
          static_armour,
        },
      )
      return
    }

    // find loc name from coverage locs for given new/equipped item using id of selected loc e.g. Lower Right Leg
    const coverage_loc = staticCoverageLocs.find(
      (loc) => loc && loc.id === equipped_armour.armour_location,
    )
    if (!coverage_loc) {
      console.error(
        '*** processAddEquippedArmour - Unable to find coverage loc for selected armour_location id:',
        equipped_armour.armour_location,
      )
      return
    }

    // ensure the character item stores the human-readable armour_location_name
    // for this specific flexible piece so that table views and later processes
    // (e.g. removeEquippedArmour) can distinguish between two identical items
    // on different locations (e.g. Left vs Right greave).
    equipped_armour.armour_location_name = coverage_loc.name

    // find character armour location with matching name to coverage loc name e.g. Lower Left Leg
    const character_armour_location = character.armour_locations.find(
      (loc) => loc.armour_location_name === coverage_loc.name,
    )

    // add armour to specific equipped armour array
    if (!character_armour_location) {
      console.error(
        '*** processAddEquippedArmour - Unable to find character armour location with matching name to coverage loc name:',
        coverage_loc.name,
      )
      return
    }

    // create entry (base per-full-location dex pen)
    const equipped_armour_entry = _createEquippedArmourEntry({
      static_armour: resolvedStaticArmour,
      equipped_armour,
      coverage_name: coverage_loc.name,
    })

    // if this armour location is flagged as half_location (e.g. Upper/Lower),
    // halve the dex penalty to mirror backend CharacterLocationEquippedArmour.get_armour_dex_pen_percent
    if (character_armour_location.half_location) {
      equipped_armour_entry.dex_pen = equipped_armour_entry.dex_pen / 2
    }
    // console.log('equipped_armour_entry = ', equipped_armour_entry)

    // push entry to array
    character_armour_location.equipped_armour.push(equipped_armour_entry)
    // recalc aggregates for this location
    _updateLocationAggregates(character_armour_location)

    // -----------------------------------------------------------------
    // update armour item headline values for table view (equipped only)
    // -----------------------------------------------------------------
    const material = resolvedStaticArmour?.armour?.armour_material || {}
    if (equipped_armour.ap === undefined || equipped_armour.ap === null) {
      equipped_armour.ap = Number(material.ap) || 0
    }
    // keep any character-specific hp override; only default from
    // material when the character item doesn't yet have a value
    if (equipped_armour.hp === undefined || equipped_armour.hp === null) {
      equipped_armour.hp = material.hp ?? null
    }
    equipped_armour.layer = material.layer ?? null
    // for flexible coverage, always show the selected location name (e.g. Lower Right Leg)
    equipped_armour.coverage = coverage_loc.name || null

    //=========================================================================
    // SCENARIO A - fixed coverage (use coverage locations from static armour)
    //-------------------------------------------------------------------------
  } else {
    const staticCoverageLocs = Array.isArray(resolvedStaticArmour?.armour?.coverage_locations)
      ? resolvedStaticArmour.armour.coverage_locations
      : []

    if (!staticCoverageLocs.length) {
      console.error(
        '*** processAddEquippedArmour - No static coverage_locations found on static_armour for fixed coverage:',
        {
          static_armour,
        },
      )
      return
    }

    // loop coverage locs from static definition
    staticCoverageLocs.forEach((cl) => {
      // find character armour location matching coverage loc name
      const character_armour_location = character.armour_locations.find(
        (loc) => loc.armour_location_name === cl.name,
      )

      if (!character_armour_location) {
        console.error(
          '*** processAddEquippedArmour - Unable to find character armour location with matching name to coverage loc name:',
          cl.name,
        )
        return
      }

      // create entry (base per-full-location dex pen)
      const equipped_armour_entry = _createEquippedArmourEntry({
        static_armour: resolvedStaticArmour,
        equipped_armour,
        coverage_name: cl.name,
      })
      console.log('equipped_armour_entry = ', equipped_armour_entry)

      // apply half-location adjustment when relevant
      if (character_armour_location.half_location) {
        equipped_armour_entry.dex_pen = equipped_armour_entry.dex_pen / 2
      }

      // push entry to array
      character_armour_location.equipped_armour.push(equipped_armour_entry)
      // recalc aggregates for this location
      _updateLocationAggregates(character_armour_location)
    })

    // -----------------------------------------------------------------
    // update armour item headline values for table view (equipped only)
    // for fixed coverage, use the static material values and let
    // coverage be derived from one of the coverage location names
    // (first coverage_loc handled above will have set this via cl.name)
    // -----------------------------------------------------------------
    const material = resolvedStaticArmour?.armour?.armour_material || {}
    if (equipped_armour.ap === undefined || equipped_armour.ap === null) {
      equipped_armour.ap = Number(material.ap) || 0
    }
    // keep any character-specific hp override; only default from
    // material when the character item doesn't yet have a value
    if (equipped_armour.hp === undefined || equipped_armour.hp === null) {
      equipped_armour.hp = material.hp ?? null
    }
    equipped_armour.layer = material.layer ?? null
    // if multiple locations, coverage string may be updated by the last
    // processed coverage_loc; this is sufficient for headline display
    if (!equipped_armour.coverage && Array.isArray(staticCoverageLocs)) {
      const firstLoc = staticCoverageLocs[0]
      equipped_armour.coverage = firstLoc ? firstLoc.name : null
    }
  }
  _updateCharacterDexPenArmour(character)
  //----------------------------------
  //
  //----------------------------------
  console.log('END processAddEquippedArmour')
  //-----------------------
  // return
  //------------------------
  return character
}
